import React from 'react';
import { ReactComponent as WarningIcon } from 'v2/icons/alert-icon-blue.svg';
import styles from './assignedColleagueIndicator.module.scss';
import { ProposalEntity, RootState } from 'v2/models';
import { useSelector } from 'react-redux';

export const colleagueAssignedText =
  'One of your colleagues is already chatting to the requestor.';

interface AssignedColleagueIndicatorProps {
  proposal: ProposalEntity;
}

export const AssignedColleagueIndicator = ({
  proposal,
}: AssignedColleagueIndicatorProps) => {
  const user = useSelector((state: RootState) => state.user.user);
  const isCollegueAssigned = proposal.assigned_to?.username !== user.username;

  return isCollegueAssigned ? (
    <div className={styles.assignedColleagueIndicator}>
      <WarningIcon />
      <p>{colleagueAssignedText}</p>
    </div>
  ) : null;
};
